import { render, staticRenderFns } from "./CustomerAdmin.vue?vue&type=template&id=1bf8cd70"
import script from "./CustomerAdmin.vue?vue&type=script&lang=js"
export * from "./CustomerAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports